import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Router } from '@angular/router';

import { environment } from 'src/environments/environment';
import { UtilService } from 'src/app/modules/shared/services/util.service';

@Injectable({
  providedIn: 'root'
})
export class CouponsService {

  constructor(
    private _router: Router,
    private _utilService: UtilService,
    private _httpClient: HttpClient
  ) { }

  // Get products
  getProducts(token: string, providerType : string, providerId: string, page: any, searchText: string){
    const URL = environment.apiUrl + 'dashboard/products';
    let reqHeaders = new HttpHeaders()
      .set('Content-Type', 'application/json')
      .set('authToken', token);
    let reqParams = new HttpParams()
      .set('provider_type', providerType)
      .set('provider_id', providerId)
      .set('page', page)
      .set('search_text', searchText);

    return this._httpClient.get<any>(URL, {headers: reqHeaders, params: reqParams});
  }

  // Get categories
  getCategories(token: string, providerType : string, providerId: string){
    const URL = environment.apiUrl + 'dashboard/categories';
    let reqHeaders = new HttpHeaders()
      .set('Content-Type', 'application/json')
      .set('authToken', token);
    let reqParams = new HttpParams()
      .set('provider_type', providerType)
      .set('provider_id', providerId);

    return this._httpClient.get<any>(URL, {headers: reqHeaders, params: reqParams});
  }

  // Manage category 
  manageCategory(token: string, body: any){
    const URL = environment.apiUrl + 'dashboard/manageCategory';
    let reqHeaders = new HttpHeaders()
      .set('Content-Type', 'application/json')
      .set('authToken', token);
    let reqBody = JSON.stringify(body);

    return this._httpClient.post<any>(URL, reqBody, {headers: reqHeaders});
  }

  // Get manufacturers
  getManufacturers(token: string, providerType : string, providerId: string, brandLink: boolean){
    const URL = environment.apiUrl + 'dashboard/manufacturers';
    let reqHeaders = new HttpHeaders()
      .set('Content-Type', 'application/json')
      .set('authToken', token);
    let reqParams = new HttpParams()
      .set('provider_type', providerType)
      .set('provider_id', providerId)
      .set('brand_link', brandLink);

    return this._httpClient.get<any>(URL, {headers: reqHeaders, params: reqParams});
  }

  // Manage manufacturer 
  manageManufacturer(token: string, body: any){
    const URL = environment.apiUrl + 'dashboard/manageManufacturer';
    let reqHeaders = new HttpHeaders()
      .set('Content-Type', 'application/json')
      .set('authToken', token);
    let reqBody = JSON.stringify(body);

    return this._httpClient.post<any>(URL, reqBody, {headers: reqHeaders});
  }

  // Get brands
  getBrands(token: string, providerType : string, providerId: string, mfgId: any){
    const URL = environment.apiUrl + 'dashboard/brands';
    let reqHeaders = new HttpHeaders()
      .set('Content-Type', 'application/json')
      .set('authToken', token);
    let reqParams = new HttpParams()
      .set('provider_type', providerType)
      .set('provider_id', providerId)
      .set('mfg_id', mfgId);

    return this._httpClient.get<any>(URL, {headers: reqHeaders, params: reqParams});
  }

  // Manage brand
  manageBrand(token: string, body: any){
    const URL = environment.apiUrl + 'dashboard/manageBrand';
    let reqHeaders = new HttpHeaders()
      .set('Content-Type', 'application/json')
      .set('authToken', token);
    let reqBody = JSON.stringify(body);

    return this._httpClient.post<any>(URL, reqBody, {headers: reqHeaders});
  }

  // Get coupon types
  getCouponTypes(token: string){
    const URL = environment.apiUrl + 'dashboard/couponTypes';
    let reqHeaders = new HttpHeaders()
      .set('Content-Type', 'application/json')
      .set('authToken', token);

    return this._httpClient.get<any>(URL, {headers: reqHeaders});
  }

  // Create coupons
  createCoupons(token: string, body: any){
    const URL = environment.apiUrl + 'dashboard/createCoupons';
    let reqHeaders = new HttpHeaders()
      .set('Content-Type', 'application/json')
      .set('authToken', token);
    let reqBody = JSON.stringify(body);

    return this._httpClient.post<any>(URL, reqBody, {headers: reqHeaders});
  }

  // Get store list
  getStores(token: string, body: any){
    const URL = environment.apiUrl + 'dashboard/retailers';
    let reqHeaders = new HttpHeaders()
      .set('Content-Type', 'application/json')
      .set('authToken', token);
    let reqBody = JSON.stringify(body);

    return this._httpClient.post<any>(URL, reqBody, {headers: reqHeaders});
  }

  // Get coupons
  getCoupons(token: string, providerType : string, providerId: string, retailerId: string, storeId: string, couponSource: string, couponStatus: string, page: any, demo: any){
    const URL = environment.apiUrl + 'dashboard/coupons';
    let reqHeaders = new HttpHeaders()
      .set('Content-Type', 'application/json')
      .set('authToken', token);
    let reqParams = new HttpParams()
      .set('provider_type', providerType)
      .set('provider_id', providerId)
      .set('retailer_id', retailerId)
      .set('store_id', storeId)
      .set('coupon_source', couponSource)
      .set('coupon_status', couponStatus)
      .set('page', page)
      .set('demo', demo);
      
    return this._httpClient.get<any>(URL, {headers: reqHeaders, params: reqParams});
  }

  // Accept/Reject CPG coupon
  reviewCoupon(token: string, body: any){
    const URL = environment.apiUrl + 'dashboard/reviewCoupon';
    let reqHeaders = new HttpHeaders()
      .set('Content-Type', 'application/json')
      .set('authToken', token);
    let reqBody = JSON.stringify(body);

    return this._httpClient.post<any>(URL, reqBody, {headers: reqHeaders});
  }

}
